import React from 'react';
import PropTypes from 'prop-types';

// material-ui
import { Alert, Avatar, Box, Collapse, IconButton, InputBase, Pagination, Paper, Stack, Typography, useMediaQuery } from '@mui/material';

// project imports
import SubCard from 'ui-component/cards/SubCard';
import { useEffect, useState } from 'react';

import { useTheme } from '@mui/styles';
import useScriptRef from 'hooks/useScriptRef';
import axios from 'axios';
import ApiLink from 'API';
import StyledDataGrid from 'ui-component/StyledDataGrid';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import PanoramaIcon from '@mui/icons-material/Panorama';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import NumberFormat from 'react-number-format';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router';
// import DeleteProduct from './DeleteProduct';
// import EditProduct from './EditProduct';
const AgentListAndModify = ({ DataArray, openBackdrop, setopenBackdrop }) => {
    const columns = [
        // { field: '_id', headerName: 'id', width: 90 },
        {
            field: 'agentsID',
            headerName: 'ID',
            width: 100,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                    {params.row.agentsID}
                </Typography>
            )
        },
        {
            field: 'agentsName',
            headerName: 'Name',
            width: 250,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', color: '#1428a0	' }}>
                    {params.row.agentsName}
                </Typography>
            )
        },
        {
            field: 'mobile',
            headerName: 'Mobile',
            width: 150,
            // headerAlign: 'center',
            // align: 'center',
            // flex: 0.8,
            renderCell: (params) => (
                <Typography variant="body2" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                    {params.row.mobile}
                </Typography>
            )
        },
        {
            field: 'contact',
            headerName: 'Contact',
            width: 200,
            // headerAlign: 'center',
            // align: 'center',
            // flex: 0.8,
            renderCell: (params) => (
                <Typography variant="body2" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                    {params.row.contact}
                </Typography>
            )
        },
        {
            field: 'description',
            headerName: 'description',
            width: 250,
            // headerAlign: 'center',
            // align: 'center',
            // flex: 0.8,
            renderCell: (params) => (
                <Typography variant="body2" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                    {params.row.description}
                </Typography>
            )
        }

        // {
        //     field: 'action',
        //     headerName: 'Action',
        //     // flex: 0.5,
        //     width: 150,
        //     sortable: false,
        //     filterable: false,
        //     headerAlign: 'center',
        //     align: 'center',
        //     renderCell: (params) => (
        //         <Stack direction="row" spacing={1}>
        //             <IconButton
        //                 color="primary"
        //                 onClick={() => {
        //                     setselectData(params.row);
        //                     setOpenEdit(true);
        //                 }}
        //             >
        //                 <EditIcon />
        //             </IconButton>
        //             <IconButton
        //                 color="error"
        //                 onClick={() => {
        //                     setselectData(params.row);
        //                     setOpenDelete(true);
        //                 }}
        //             >
        //                 <DeleteIcon />
        //             </IconButton>
        //         </Stack>
        //     )
        //     // editable: true
        // }
    ];
    const navigate = useNavigate();
    const [ProductData, setProductData] = useState([]);
    const [Value, setValue] = useState('');
    const [page, setpage] = useState(1);
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const scriptedRef = useScriptRef();
    const [totalPage, settotalPage] = useState(0);
    const [total, settotal] = useState(0);
    const [AlertBox, setAlertBox] = useState({ open: false, message: '', severity: 'error' });
    const [OpenDelete, setOpenDelete] = useState(false);
    const [OpenEdit, setOpenEdit] = useState(false);
    const [selectData, setselectData] = useState({});
    const handlePage = (event, value) => {
        setpage(value);
    };
    async function LoadData(ValueSearch) {
        try {
            setProductData([]);
            setopenBackdrop(true);
            const valueReplate = ValueSearch === '' ? '^' : ValueSearch.toLowerCase();

            const response = await axios.get(ApiLink + '/api/agents/' + valueReplate, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (response.status === 200) {
                setProductData(response.data.data);
                settotal(response.data.total);
                settotalPage(response.data.totalPage);
                setopenBackdrop(false);
            } else if (response.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            console.log(error);
            if (error.response.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        }
    }
    // useEffect(() => {
    //     LoadData();
    // }, []);
    useEffect(() => {
        LoadData(Value);
    }, [page]);
    useEffect(() => {
        if (DataArray.data) {
            setProductData(DataArray.data);
            settotal(DataArray.total);
            settotalPage(DataArray.totalPage);
            setpage(1);
            setValue('');
        }
    }, [DataArray]);
    return (
        <SubCard
            title="Agent List"
            contentSX={{ p: 0 }}
            show={true}
            // secondary={
            //     <Paper style={{ display: 'flex', width: matchDownSM ? 180 : 300 }} elevation={2}>
            //         <InputBase
            //             type="text"
            //             fullWidth
            //             disabled={openBackdrop}
            //             style={{
            //                 marginLeft: 1,
            //                 flex: 1
            //             }}
            //             value={Value}
            //             onChange={(event) => {
            //                 setValue(event.target.value);
            //             }}
            //             onKeyDown={(e) => {
            //                 if (e.keyCode == 13) {
            //                     setpage(1);
            //                     LoadData(Value);
            //                 }
            //             }}
            //             style={{ fontFamily: 'boonhome-400' }}
            //             placeholder="ID, Name, Model"
            //             inputProps={{ 'aria-label': 'ID, Name, Model' }}
            //             startAdornment={
            //                 <IconButton
            //                     disabled={openBackdrop}
            //                     className="iconbutton"
            //                     aria-label="search"
            //                     onClick={(e) => {
            //                         setpage(1);
            //                         LoadData(Value);
            //                     }}
            //                 >
            //                     <SearchIcon />
            //                 </IconButton>
            //             }
            //             endAdornment={
            //                 <IconButton
            //                     disabled={openBackdrop}
            //                     className="iconbutton"
            //                     aria-label="refresh"
            //                     onClick={() => {
            //                         // setData(dataOriginal);
            //                         setValue('');
            //                         LoadData('');
            //                     }}
            //                 >
            //                     <RefreshIcon />
            //                 </IconButton>
            //             }
            //         />
            //     </Paper>
            // }
        >
            {/* <DeleteProduct open={OpenDelete} setOpen={setOpenDelete} dateRemove={selectData} Getdata={LoadData} setAlert={setAlertBox} /> */}
            {/* <EditProduct open={OpenEdit} setOpen={setOpenEdit} Data={selectData} Getdata={LoadData} /> */}
            <Collapse in={AlertBox.open}>
                <Alert
                    sx={{ padding: '10px', mb: 2 }}
                    // variant="outlined"
                    severity={AlertBox.severity}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setAlertBox({ ...AlertBox, open: false });
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                >
                    {AlertBox.message}
                </Alert>
            </Collapse>
            <Box
                // style={{
                //     width: '100%',
                //     height: '80vh',
                //     textAlign: 'center'
                //     // overflow: "auto",
                // }}
                sx={{ width: '100%', height: '80vh', textAlign: 'center', border: 0, borderRadius: 16 }}
            >
                <StyledDataGrid
                    loading={openBackdrop}
                    getRowId={(row) => row._id}
                    rows={ProductData}
                    columns={columns}
                    // pageSize={20}
                    rowHeight={100}
                    headerHeight={60}
                    // hideFooter={true}
                    // autoHeight={true}
                    // rowsPerPageOptions={[5]}
                    // checkboxSelection
                    // disableSelectionOnClick
                />
            </Box>
            {/* <Box
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: '5px'
                }}
            >
                <Pagination
                    disabled={openBackdrop}
                    count={totalPage}
                    // variant="outlined"
                    page={page}
                    size="small"
                    shape="rounded"
                    color="primary"
                    onChange={handlePage}
                    showFirstButton
                    showLastButton
                />
            </Box>
            <p
                style={{
                    fontSize: '10px',
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: '5px'
                }}
            >
                Total : {total}
            </p> */}
        </SubCard>
    );
};

export default AgentListAndModify;
